import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/system';

import mixinSx from './mixinSx';

export function tooltipLightSlotProps(additionalSx?: SxProps<Theme>) {
  return {
    slotProps: {
      tooltip: {
        sx: mixinSx(
          {
            backgroundColor: (theme) => theme.palette.white,
            color: (theme) => theme.palette.grey70,
            outlineColor: (theme) => `${theme.palette.grey100}16`,
          },
          additionalSx
        ),
      },
    },
  };
}
